import { Serializable } from "./Serializable";

export class UserIntegrations implements Serializable<UserIntegrations> {
    zoom: boolean;
    azureCalendar: boolean;
    deserialize(input: any) {
        input.zoom && (this.zoom = input.zoom);
        input.azureCalendar && (this.azureCalendar = input.azureCalendar);
        return this;
    }

    constructor() {
        this.zoom = false;
        this.azureCalendar = false;
    }
}
